import React from 'react';
import { cn } from '../../utils/cn';
import { Heading, Text } from './Typography';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'elevated';
}

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}

interface CardTitleProps {
  children: React.ReactNode;
  className?: string;
}

interface CardDescriptionProps {
  children: React.ReactNode;
  className?: string;
}

interface CardContentProps {
  children: React.ReactNode;
  className?: string;
}

interface CardFooterProps {
  children: React.ReactNode;
  className?: string;
}

export function Card({ children, className = '', variant = 'default' }: CardProps) {
  const variantClasses = {
    default: 'card',
    elevated: 'card shadow-md',
  };

  return (
    <div className={cn(variantClasses[variant], className)}>
      {children}
    </div>
  );
}

export function CardHeader({ children, className = '' }: CardHeaderProps) {
  return (
    <div className={cn('card-header', className)}>
      {children}
    </div>
  );
}

export function CardTitle({ children, className = '' }: CardTitleProps) {
  return (
    <Heading level={4} className={cn('text-primary', className)}>
      {children}
    </Heading>
  );
}

export function CardDescription({ children, className = '' }: CardDescriptionProps) {
  return (
    <Text size="sm" className={cn('mt-1 text-secondary', className)}>
      {children}
    </Text>
  );
}

export function CardContent({ children, className = '' }: CardContentProps) {
  return (
    <div className={cn('card-body', className)}>
      {children}
    </div>
  );
}

export function CardFooter({ children, className = '' }: CardFooterProps) {
  return (
    <div className={cn('card-footer', className)}>
      {children}
    </div>
  );
}
